// removed by extract-text-webpack-plugin
module.exports = {"block":"Description__block-4XIOp"};